import styled from "styled-components";
import { Edit } from "@styled-icons/boxicons-solid/Edit";

// Make the styling dynamic by accessing props
const Editicon = styled(Edit)<{
  iconsize?: string;
  defaultcolor?: string;
  hovercolor?: string;
  focuscolor?: string;
}>`
  width: ${({ iconsize }) => iconsize || "24px"};
  height: ${({ iconsize }) => iconsize || "24px"};
  color: ${({ defaultcolor }) => defaultcolor || "#6a6a6a"};
  cursor: pointer;

  &:hover {
    color: ${({ hovercolor }) => hovercolor || "#36429e"};
  }

  &:focus,
  &:active {
    color: ${({ focuscolor }) => focuscolor || "#4453c5"};
  }
`;

function EditIcon(props: {
  handleEdit?: () => void;
  iconsize?: string;
  defaultcolor?: string;
  hovercolor?: string;
  focuscolor?: string;
}) {
  return (
    <Editicon
      onClick={props.handleEdit}
      iconsize={props.iconsize}
      defaultcolor={props.defaultcolor}
      hovercolor={props.hovercolor}
      focuscolor={props.focuscolor}
    />
  );
}

export default EditIcon;
